export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Якщо ви скасуєте угоду, вона буде закрита без завершення операції."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви впевнені, що хочете скасувати угоду?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Так, скасувати"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ні, залишити активною"])}
}